<template>
  <GBox
    flex
    class="announcement-wrapper"
  >
    <GBox class="report-announcement">
      <AnnouncementSlider
        @onActiveSliderIndexChange="onActiveSliderIndexChange"
        :class="{announcementSlider: true, isReportVisible: activeSliderIndex<3}"
      />
      <GBox
        flex
        class="-wrapper"
        justify="center"
        :mt="10"
        v-if="activeSliderIndex<3"
      >
        <GText>
          Tüm veriler
          <a
            rel="noopener"
            href="https://tymp.mncdn.com/prod/Trendyol-Etki-Raporu.pdf"
            class="sc-link"
            target="_blank"
          >
            Trendyol Etki Raporu'ndan
          </a> alınmıştır.
        </GText>
      </GBox>
    </GBox>
    <AnnouncementWidgets class="announcement-widgets" />
  </GBox>
</template>

<script>
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import AnnouncementSlider from '@/views/LoginNew/AnnouncementSlider';
import AnnouncementWidgets from '@/views/LoginNew/AnnouncementWidgets';

export default {
  name: 'Announcement',

  components: {
    AnnouncementWidgets,
    AnnouncementSlider,
    GBox,
    GText,
  },

  data () {
    return {
      activeSliderIndex: 0,
    };
  },

  methods: {
    onActiveSliderIndexChange (activeSliderIndex) {
      this.activeSliderIndex = activeSliderIndex;
    },
  },
};
</script>

<style scoped lang="scss">
  .announcement-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .report-announcement {
      background-color: #ffffff;
      height: 100%;
      margin-bottom: 20px;
      border-radius: 6px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .report-wrapper {
        text-align: center;
      }
    }

    .announcementSlider:not(.isReportVisible){
      margin-bottom: 27px;
    }

    @media only screen and (max-width:1024px) {
      .announcement-widgets {
        display: none;
      }
      .report-announcement {
        margin-bottom: 0;
      }
    }

    @media only screen and (max-width:767px) {
      .report-announcement {
        margin-top: 30px;
      }
    }
  }
</style>
